import { logger } from "./logger";

const log = logger.info.bind(logger);

function timedMethod(className: string): (methodName: string, descriptor: PropertyDescriptor) => PropertyDescriptor {
  return (methodName: string, descriptor: PropertyDescriptor): PropertyDescriptor => {
    let method = descriptor.value;
    descriptor.value = function (...args: any[]) {
      const start = Date.now();
      let result: any;
      try {
        // tslint:disable-next-line:no-invalid-this
        result = method.apply(this, args);
      } catch (e) {
        log(`Method ${className}.${methodName} failed after ${Date.now() - start} ms`);
        throw e;
      }
      if (result?.then) {
        result
          .then(() => log(`Method ${className}.${methodName} took ${Date.now() - start} ms`))
          .catch(() => log(`Method ${className}.${methodName} rejected after ${Date.now() - start} ms`));
      } else {
        log(`Method ${methodName} took ${Date.now() - start} ms`);
      }
      return result;
    };
    return descriptor;
  };
}

export function Timed<T>(target: new (...params: any[]) => T) {
  for (const key of Object.getOwnPropertyNames(target.prototype)) {
    let descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);
    if (descriptor && descriptor.value) {
      descriptor = timedMethod(target.name)(key, descriptor);
      Object.defineProperty(target.prototype, key, descriptor);
    }
  }
}
